(function() {
  if (window.__apbInit) return;
  window.__apbInit = true;

  function init() {
    var box = document.querySelector('[data-apb]');
    if (!box) return;

    var THRESHOLD = parseInt(box.getAttribute('data-threshold'), 10) || 500000;
    var COUNTDOWN_HOURS = parseInt(box.getAttribute('data-countdown-hours'), 10) || 8;
    var moneyFormat = (window.Shopify && Shopify.money_format) || 'Tk {{amount}} BDT';

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function getCountdownEnd() {
      var key = 'apb_countdown_end';
      var stored = parseInt(localStorage.getItem(key), 10);
      var now = Date.now();
      if (!stored || isNaN(stored) || stored <= now) {
        stored = now + (COUNTDOWN_HOURS * 3600 * 1000);
        localStorage.setItem(key, stored);
      }
      return stored;
    }

    function tickCountdown() {
      var end = getCountdownEnd();
      var diff = end - Date.now();
      if (diff <= 0) {
        localStorage.removeItem('apb_countdown_end');
        end = getCountdownEnd();
        diff = end - Date.now();
      }
      var hrs = Math.floor(diff / 3600000);
      var min = Math.floor((diff % 3600000) / 60000);
      var sec = Math.floor((diff % 60000) / 1000);
      var h = box.querySelector('[data-apb-hrs]');
      var m = box.querySelector('[data-apb-min]');
      var s = box.querySelector('[data-apb-sec]');
      if (h) h.textContent = pad(hrs);
      if (m) m.textContent = pad(min);
      if (s) s.textContent = pad(sec);
    }

    tickCountdown();
    setInterval(tickCountdown, 1000);

    function formatMoney(cents) {
      var amt = (cents / 100);
      var parts = amt.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var amountStr = parts.join('.');
      if (moneyFormat && moneyFormat.indexOf('{{amount}}') !== -1) {
        return moneyFormat.replace('{{amount}}', amountStr).replace(/<\/?[^>]+(>|$)/g, '');
      }
      return 'Tk ' + amountStr + ' BDT';
    }

    function updateShippingBar(totalCents) {
      var shipMsg = box.querySelector('[data-apb-ship-msg]');
      var shipFill = box.querySelector('[data-apb-ship-fill]');
      if (shipFill) {
        var prog = Math.min(100, Math.round(totalCents * 100 / THRESHOLD));
        shipFill.style.width = prog + '%';
      }
      if (shipMsg) {
        if (totalCents >= THRESHOLD) {
          shipMsg.innerHTML = 'You qualify for <b>FREE Delivery</b>';
          shipMsg.classList.add('apb__ship-msg--win');
        } else {
          var need = THRESHOLD - totalCents;
          shipMsg.innerHTML = 'Add <b>' + formatMoney(need) + '</b> more to unlock <b>FREE Delivery</b>';
          shipMsg.classList.remove('apb__ship-msg--win');
        }
      }
    }

    function getCurrentVariantPrice() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return 0;
      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return 0;
      var vid = parseInt(idInput.value, 10);
      var pj = document.querySelector('script[type="application/json"][data-product-json], product-info script[type="application/json"]');
      if (!pj) return 0;
      try {
        var data = JSON.parse(pj.textContent);
        var variants = data.variants || (data.product && data.product.variants);
        if (!variants) return 0;
        var v = variants.find(function(x) { return x.id === vid; });
        return v ? v.price : 0;
      } catch(err) { return 0; }
    }

    function refreshFromCart() {
      var variantPrice = getCurrentVariantPrice();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var cartTotal = (cart && cart.items_subtotal_price) ? cart.items_subtotal_price : 0;
          var effective = cartTotal > 0 ? cartTotal : variantPrice;
          updateShippingBar(effective);
        })
        .catch(function() {
          updateShippingBar(variantPrice);
        });
    }

    function updateFor(variant) {
      if (!variant) return;
      var saleEl = box.querySelector('[data-apb-sale]');
      var compareEl = box.querySelector('[data-apb-compare]');
      var saveEl = box.querySelector('[data-apb-save]');
      var pctBadge = box.querySelector('[data-apb-pct-badge]');
      if (saleEl) saleEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        var diff = variant.compare_at_price - variant.price;
        var pct = Math.round((diff / variant.compare_at_price) * 100);
        if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
        if (saveEl) { saveEl.textContent = 'Save ' + formatMoney(diff) + ' (' + pct + '% OFF)'; saveEl.style.display = ''; }
        if (pctBadge) { pctBadge.textContent = pct + '% OFF'; pctBadge.style.display = ''; }
      } else {
        if (compareEl) compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
        if (pctBadge) pctBadge.style.display = 'none';
      }
      refreshFromCart();
    }

    refreshFromCart();

    document.addEventListener('variant:change', function(e) {
      var v = e.detail && e.detail.variant;
      if (v) updateFor(v);
    });

    document.addEventListener('change', function(e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('variant-radios input, variant-selects select, variant-selects input, fieldset input[name^="options"]')) {
        setTimeout(function() {
          var form = document.querySelector('form[action*="/cart/add"]');
          if (!form) return;
          var idInput = form.querySelector('input[name="id"]');
          if (!idInput) return;
          var vid = parseInt(idInput.value, 10);
          var pj = document.querySelector('script[type="application/json"][data-product-json], product-info script[type="application/json"]');
          if (!pj) return;
          try {
            var data = JSON.parse(pj.textContent);
            var variants = data.variants || (data.product && data.product.variants);
            if (!variants) return;
            var v = variants.find(function(x) { return x.id === vid; });
            if (v) updateFor(v);
          } catch(err) {}
        }, 80);
      }
    });

    document.addEventListener('cart:refresh', refreshFromCart);
    document.addEventListener('cart:update', refreshFromCart);

    var origFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      var promise = origFetch.apply(this, args);
      try {
        var url = (args[0] && args[0].url) || args[0] || '';
        if (typeof url === 'string' && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
          promise.then(function() { setTimeout(refreshFromCart, 200); });
        }
      } catch(e) {}
      return promise;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();